/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 0d8241bb585e991ed897c2cca97a0cb3 */

import { ConcreteRequest } from "relay-runtime";

export type ApprovalStatus = "ACTIVE" | "ARCHIVED" | "INACTIVE" | "PENDING" | "%future added value";
export type InviteStatus = "ACCEPTED" | "PENDING" | "REJECTED" | "UNSENT" | "%future added value";
export type PartnerRole = "COMPANY_ADMIN" | "MARKETING" | "MEMBER" | "OPERATIONS" | "OWNER" | "SALES" | "TECHNICIAN" | "%future added value";
export type NotificationsQueryVariables = {};
export type NotificationsQueryResponse = {
    readonly viewer: {
        readonly id: string | null;
        readonly partnerUsers: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly status?: ApprovalStatus | null | undefined;
                    readonly role?: ReadonlyArray<PartnerRole | null> | null | undefined;
                    readonly invites?: {
                        readonly edges: ReadonlyArray<{
                            readonly node: {
                                readonly id: string | null;
                                readonly status: InviteStatus | null;
                                readonly expiresAt: string | null;
                            };
                        } | null>;
                    } | null | undefined;
                };
            } | null>;
        } | null;
    } | null;
};
export type NotificationsQuery = {
    readonly response: NotificationsQueryResponse;
    readonly variables: NotificationsQueryVariables;
};



/*
query NotificationsQuery {
  viewer {
    id
    partnerUsers {
      edges {
        node {
          __typename
          ... on PartnerUser {
            status
            role
            invites {
              edges {
                node {
                  id
                  status
                  expiresAt
                }
              }
            }
          }
          id
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = {
  "kind": "InlineFragment",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InviteConnection",
      "kind": "LinkedField",
      "name": "invites",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InviteEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Invite",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expiresAt",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PartnerUser",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CorePartnerUserConnection",
            "kind": "LinkedField",
            "name": "partnerUsers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CorePartnerUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NotificationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CorePartnerUserConnection",
            "kind": "LinkedField",
            "name": "partnerUsers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CorePartnerUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v0/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "0d8241bb585e991ed897c2cca97a0cb3",
    "metadata": {},
    "name": "NotificationsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = '3de58861d6da5a03bf26c3683c63a917';
export default node;
